import { ReactComponent as CodeIcon } from 'assets/icons/inlineCode24.svg'
import cx from 'classnames'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { useInlineCodeToggle } from 'common/Prose/Toolbar/hooks/useInlineCodeToggle'
import { Button } from 'components/Button'
import { ButtonProps } from 'components/Button/Types'
import { observer } from 'mobx-react-lite'
import Styles from '../../MobileToolbar.module.scss'

export const CodeMark = observer((props: ButtonProps) => {
  const view = useEditorView()
  const { active, disabled, handleClick } = useInlineCodeToggle(view)

  return (
    <Button
      preventFocusOnPress
      variant="none"
      size="sm"
      aria-label={'Toggle inline code'}
      className={cx(Styles.button, {
        [Styles.buttonSelected]: active,
        [Styles.disabled]: disabled,
      })}
      onClick={handleClick}
      data-testid="mobile-toolbar-code-mark"
      {...props}
    >
      <CodeIcon />
    </Button>
  )
})
